/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 warum.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Warum(props) {
  const { nodes, materials } = useGLTF('/media/models/warum.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Text.geometry} material={materials.Material} />
    </group>
  )
}

useGLTF.preload('/media/models/warum.glb')
